'use strict';

module.exports = 30000;
